const STATUS_NAMESPACES = [
  "owner_booking.status.",
  "calendar.status.",
  "trip.timeline.",
  "trip.status.",
  "booking.",
] as const;

const STATUS_LABELS: Record<string, string> = {
  accepted_pending_verification: "Confirmed: driver checks pending",
  accepted_payment_pending: "Accepted: payment pending",
  awaiting_host: "Waiting for host response",
  waiting_for_host: "Waiting for host response",
  payment_failed: "Payment failed",
  pending: "Pending",
  approved: "Approved",
  confirmed: "Confirmed",
  trip_confirmed: "Confirmed",
  active: "In progress",
  in_progress: "In progress",
  completed: "Completed",
  cancelled: "Cancelled",
  declined: "Declined",
  expired: "Expired",
  no_show: "No-show",
  unknown: "Unknown",
};

/** Reduce either an API enum or a translation key to a stable status slug. */
export function normalizeStatusKey(status: string | null | undefined): string {
  let key = String(status ?? "").trim().toLowerCase();
  for (const namespace of STATUS_NAMESPACES) {
    if (key.startsWith(namespace)) {
      key = key.slice(namespace.length);
      break;
    }
  }
  if (key.startsWith("trip.status_")) key = key.slice("trip.status_".length);
  return key.replace(/[.\s-]+/g, "_").replace(/_+/g, "_");
}

/** Safe English fallback for missing locale entries and unknown server enums. */
export function formatStatusLabel(status: string | null | undefined): string {
  const key = normalizeStatusKey(status);
  const known = STATUS_LABELS[key];
  if (known) return known;
  const words = key.split("_").filter(Boolean);
  if (words.length === 0) return "Unknown";
  return words.map((word, index) => index === 0
    ? `${word[0].toUpperCase()}${word.slice(1)}`
    : word,
  ).join(" ");
}